type SigningDeployment = {
  chainId: string;
  proxyAddress: string;
};

// Launch preparation only: no deployment is opted in yet. Add an exact pair
// only before that fresh deployment creates any wallet-derived accounts.
// Once published, preserve the pair forever; changing it changes identities.
const freshDeployments: SigningDeployment[] = [];

export const CLEAN_SIGNING_DEPLOYMENTS: readonly Readonly<SigningDeployment>[] =
  Object.freeze(
    freshDeployments.map((deployment) => Object.freeze({ ...deployment }))
  );
